import {
  IdleTimeKpiResponse,
} from '../../../types/Manager/idleTime.types';

type Props = {
  kpi: IdleTimeKpiResponse | null;
};

const IdleReportHeader = ({
  kpi,
}: Props) => {

  const employeeName =
    localStorage.getItem(
      'employeeName',
    ) ?? '';

  return (
    <div
      className="
        mb-5
        flex
        min-w-0
        flex-wrap
        items-center
        gap-3

        [@media(max-width:1100px)]:gap-2

        [@media(max-width:1000px)]:gap-1.5
      "
    >

      {/* ================================================================
          TITLE
      ================================================================= */}

      <h1
        className="
          min-w-0
          whitespace-nowrap

          text-xl
          font-bold
          text-slate-800

          [@media(max-width:1100px)]:text-lg

          [@media(max-width:1000px)]:text-[16px]
        "
      >
        Span Idle %

        <span
          className="
            ml-2
            text-blue-600

            [@media(max-width:1100px)]:ml-1.5

            [@media(max-width:1000px)]:ml-1
          "
        >
          •{' '}
          {kpi?.spanIdlePercentage.toFixed(
            2,
          ) ?? '0.00'}
          %
        </span>
      </h1>


      {/* ================================================================
          TARGET / TEAM INFO
      ================================================================= */}

      <div
        className="
          min-w-0
          max-w-full
          overflow-hidden
          text-ellipsis
          whitespace-nowrap

          rounded-full
          bg-blue-50

          px-4
          py-1

          text-xs
          text-blue-600

          [@media(max-width:1100px)]:px-3
          [@media(max-width:1100px)]:py-[3px]
          [@media(max-width:1100px)]:text-[11px]

          [@media(max-width:1000px)]:px-2.5
          [@media(max-width:1000px)]:py-[2px]
          [@media(max-width:1000px)]:text-[10px]
        "
        title={`
          Target ≤${kpi?.targetPercentage ?? 0}%
          · ${employeeName}
          · ${kpi?.totalAssociates ?? 0} Associates
        `}
      >
        Target ≤
        {kpi?.targetPercentage ?? 0}%
        {' · '}
        {employeeName}
        {' · '}
        {kpi?.totalAssociates ?? 0}
        {' Associates'}
      </div>

    </div>
  );
};

export default IdleReportHeader;